import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

const SearchHeader = ({ showSearch, searchTerm, setSearchTerm, isLoading }) => {
    return (
        <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold">Purchase History</h1>
            {(showSearch && !isLoading) && (
                <div className="hidden lg:flex items-center gap-4">
                    <div className="relative">
                        <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-500" />
                        <Input
                            placeholder="Search invoices..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pl-8 bg-white"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchHeader;